import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { getClosestPartnerInclusiveItemTypeToGroupNestedAscendingQueryDef } from '@iotv/datamodel-core';
import { TabContext, TabPanel } from '@mui/lab';
import { Box, Tab, Tabs } from '@mui/material';
import { isAdminRole } from '../../../helpers/access';
import { queryForTypeFromStateOrFetch } from '../../../helpers/applicationDataHelpers';
import { useMostProximateCustomer } from '../../../hooks/useMostProximateCustomer';
import { useTabHandlerStringKeys } from '../../../hooks/useTabHandler';
import { ShowDefinedEntriesOnlyOpts } from '../../../types';
import { UserDetailCard } from '../../../v2/components/generic/ObjectView/DetailCard/UserDetailCard';
import { ObjectHeader } from '../../../v2/components/generic/ObjectView/ObjectHeader';
import { getViewDefintionFromObject } from '../../factories/AttributeDefinitions';
import { AutoTab } from '../../PropertyArea';
import { GroupViewDefinition } from '../Devices/DeviceGatewayGroupViewSubParts';
import { UsersGroupsTab } from './UsersGroupsTab';
export const UserView = (props) => {
    const { viewObject, applicationData, user: contextUser, contextCustomer, transactionFunctions, userFunctions, userSelectedGroup, allowedActions, isSmallView, } = props;
    const viewedUser = viewObject.matchedPrimary;
    const mostProximateCustomer = useMostProximateCustomer({ item: viewedUser, query: true });
    const userViewDefinition = viewedUser ? getViewDefintionFromObject(viewedUser) : GroupViewDefinition;
    // Check if user has a partner parent ergo is a partner user
    const partnerTree = queryForTypeFromStateOrFetch({
        contextObject: viewedUser,
        queryDef: getClosestPartnerInclusiveItemTypeToGroupNestedAscendingQueryDef({
            sourceItemType: 'User',
            groupDefiningObjectTypeId: 'Customer',
        }),
        userFunctions,
        applicationData,
        soughtType: 'Partner',
    });
    const isPartnerUser = partnerTree.length > 0;
    // Tabs
    const tabs = [
        {
            label: 'Details',
            value: 'details',
            component: viewedUser ? (_jsx(UserDetailCard, { matchedPrimary: viewedUser,
                mostProximateCustomer,
                userFunctions,
                transactionFunctions,
                viewDefinition: userViewDefinition,
                definedEntriesOnlyOpt: ShowDefinedEntriesOnlyOpts.Yes,
                requiredRoles: isPartnerUser ? ['Partner'] : undefined,
                allowedActions,
                contextUser,
                isSmallView: isSmallView })) : (_jsx(_Fragment, {})),
        },
        ...(isAdminRole(userSelectedGroup)
            ? [
                {
                    label: "User's Groups",
                    value: 'groups',
                    component: viewedUser ? (_jsx(UsersGroupsTab, { user: viewedUser,
                        transactionFunctions,
                        userFunctions })) : (_jsx(_Fragment, {})),
                },
            ]
            : []),
    ];
    const tabKeyMap = Object.fromEntries(tabs.map((t) => [t.value, t]));
    const { state: [[value, setValue]], handlers: { handleTabChange }, } = useTabHandlerStringKeys(tabKeyMap);
    return viewedUser ? (_jsxs(_Fragment, { children: [_jsx(ObjectHeader, { vob: viewedUser }), _jsx(TabContext, { value: value, children: _jsxs(Box, { sx: { width: '100%', overflowX: 'auto' }, children: [_jsx(Tabs, { value: value, onChange: handleTabChange, children: tabs.map((t) => (_jsx(Tab, { label: t.label, value: t.value, sx: { textTransform: 'none' } }, t.value))) }), tabs.map((t) => {
                            return (_jsx(TabPanel, { value: t.value, sx: { padding: 0, paddingBlockStart: 1 }, children: _jsx(AutoTab, { tabDef: t, viewObject: viewObject, contextObject: viewedUser, contextCustomer: contextCustomer, mostProximateCustomer: mostProximateCustomer, userFunctions: userFunctions, transactionFunctions: transactionFunctions }) }, `${t.value}_tabPanel`));
                        })] }) }, 'CustomerViewBoxTabContext')] })) : (_jsx(_Fragment, {}));
};
